jQuery(function($) {
    if ($('.contact-section').length == 0) {
        return;
    }

    function animateInCircle(element, radiusX, radiusY, centerX, centerY, startAngle, duration, reverse = false) {
        let angle = startAngle;
        const multiplier = $(window).width() < 767 ? 1.8 : 1; // Adjust this multiplier for a more pronounced horizontal stretch

        function step() {
            let left = centerX + (radiusX * Math.cos(angle * Math.PI / 180) * multiplier);
            let top = centerY + radiusY * Math.sin(angle * Math.PI / 180);

            $(element).css({
                'left': left + '%',
                'top': top + '%',
            });

            if (reverse) {
                angle -= (360 / (duration / 1000)) / 60; 
                if (angle <= -360) angle = 0;
            } else {
                angle += (360 / (duration / 1000)) / 60; 
                if (angle >= 360) angle = 0;
            }

            requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
    }

    animateInCircle('.square1', 34, 34, 50, 50, 0, 150000, true);
    animateInCircle('.square2', 46, 46, 50, 50, 35, 150000, true);
    animateInCircle('.square3', 46, 46, 50, 50, 70, 150000, true);
    animateInCircle('.square4', 34, 34, 50, 50, 105, 150000, true);
    animateInCircle('.square5', 34, 34, 50, 50, 140, 150000, true);
    animateInCircle('.square6', 46, 46, 50, 50, 175, 150000, true);
    animateInCircle('.square7', 34, 34, 50, 50, 210, 150000, true);
    animateInCircle('.square8', 46, 46, 50, 50, 245, 150000, true);
    animateInCircle('.square9', 46, 46, 50, 50, 280, 150000, true);

    animateInCircle('.image1', 40, 40, 50, 50, 40, 150000);
    animateInCircle('.image2', 40, 40, 50, 50, 70, 150000);
    animateInCircle('.image3', 40, 40, 50, 50, 115, 150000);
    animateInCircle('.image4', 40, 40, 50, 50, 170, 150000);
    animateInCircle('.image5', 40, 40, 50, 50, 210, 150000);
    animateInCircle('.image6', 40, 40, 50, 50, 260, 150000);
    animateInCircle('.image7', 40, 40, 50, 50, 310, 150000);
    animateInCircle('.image8', 40, 40, 50, 50, 350, 150000);
});
